<template>
  <v-container fluid class=" pa-0">
    <v-progress-linear v-if="loading" :indeterminate="true"/>
    <v-dialog v-model="showExportDialog" persistent>
      <v-card>
        <v-card-actions>
          <v-spacer/>
          <v-btn outlined :loading="exporting" @click="showExportDialog=false">Close</v-btn>
        </v-card-actions>
        <v-card-title v-if="exporting">Exporting</v-card-title>
        <v-card-title v-if="!exporting">Exporting Completed</v-card-title>
        <v-card-text>
          <span v-if="exporting"> {{ exportStatus.tasksCompleted }} of {{ exportStatus.tasksToComplete }}</span>
          <span v-if="!exporting">{{ exportStatus.tasksToComplete }} uids exported</span>
          <v-list dense>
            <v-list-item v-for="(e,index) of (exportStatus.errors||[])" v-bind:key="index">
              <v-list-item-content>
                <v-list-item-title>
                  {{ e.errorMessage }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ formatOnfleetPayload(e.onfleetPayload) }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn outlined :loading="exporting" @click="showExportDialog=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog :value="printScaleRejected !== null" max-width="420" persistent data-cy="packing-print-scale-warning">
      <v-card>
        <v-card-title>Print scale out of range</v-card-title>
        <v-card-text>
          "{{ printScaleRejected }}" cannot be used as the print scale. The scale is a fraction of actual size
          between {{ printScaleRange.min }} and {{ printScaleRange.max }}: 1 prints at actual size, and 0.6 shrinks
          everything to 60% so more fits on a page. It has been set back to 1.
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text color="primary" data-cy="packing-print-scale-warning-ok" @click="printScaleRejected = null">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showAssignInProgress" max-width="400" persistent>
      <v-card>
        <v-card-title>Working...</v-card-title>
        <v-card-text>
          Assigning bins, please be patient, this will take a few moments
        </v-card-text>
        <v-card-text class="text-center">
          <v-progress-circular indeterminate/>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showClearInProgress" max-width="400" persistent>
      <v-card>
        <v-card-title>Working...</v-card-title>
        <v-card-text>
          Clearing bin assignments, please be patient, this will take a few moments
        </v-card-text>
        <v-card-text class="text-center">
          <v-progress-circular indeterminate/>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div class="orders" v-if="!loading">

      <v-dialog
        v-model="showMissing"
        ref="dialogMissing"
        width="500px"
      >
        <v-card>
          <v-card-title>Warning</v-card-title>
          <v-card-text>
            The following meal ids were not found in the database. Any ingredients required for these meals is not show.
            <v-list>
              <v-list-item v-for="mealId of missing_meals" v-bind:key="mealId">
                {{ missing_count[mealId] }} orders for {{ mealId }}
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-footer fixed class="d-print-none pl-10 pr-8" v-if="datesFormatted">
        {{ datesFormatted }}
        <v-spacer/>
        {{ totalCount }} meals
        {{ orders.length }} orders
        {{ selectedUids.length }} deliveries
        <v-spacer/>
        <v-chip
          v-if="missing_meals.size"
          color="warning" class="mr-1"
          @click="showMissing=true"
        >{{ missing_meals.size }} meals not found
        </v-chip>
        <!--      <v-chip color="secondary"-->
        <!--              close-->
        <!--              @click:close="selected=[]"-->
        <!--              v-if="totalRawSelected">Raw Selected {{ totalRawSelected }}-->
        <!--      </v-chip>-->
        <!--      <v-chip color="primary" v-if="!totalRawSelected">Raw Total {{ totalRawAll }}</v-chip>-->
      </v-footer>
      <v-alert class="d-print-none" color="red" v-if="isAdmin">Danger Danger! Admin mode</v-alert>
      <v-toolbar flat class="d-print-none">
        <v-spacer/>
        <v-btn-toggle
          v-model="groupBy"
          tile
          group
          prefix="Group By"
        >
          <v-btn value="customer">By Customer</v-btn>
          <v-btn value="meal">By Meal</v-btn>
          <v-btn value="rack">By Rack</v-btn>
          <v-btn value="none">No grouping</v-btn>
          <v-btn value="bag">Box Stickers</v-btn>
          <v-btn value="shippingLabel">Shipping Labels</v-btn>
          <v-btn value="deliveryList">Delivery List</v-btn>
          <v-btn value="raw">Data Export</v-btn>
          <v-btn value="bins">Bin Labels</v-btn>
        </v-btn-toggle>
        <v-spacer/>
        <DebouncedTextField
          v-model.number="printScale"
          :debounce="500"
          label="Print scale"
          hint="1 = actual size"
          persistent-hint
          type="number"
          step="0.05"
          :min="printScaleRange.min"
          :max="printScaleRange.max"
          single-line
          style="max-width: 110px"
          data-cy="packing-print-scale"
        />
      </v-toolbar>
      <v-toolbar flat class="d-print-none pb-10">
        <ShippingGroupSelector
          :dates="dates" :shipping-group="shippingGroup"
          v-on:update:dates="dates=$event"
          v-on:update:shippingGroup="shippingGroup=$event"
        />
        <!--                <v-spacer/>-->
        <!--                <v-text-field-->
        <!--                    v-model="search"-->
        <!--                    append-icon="mdi-magnify"-->
        <!--                    label="Search..."-->
        <!--                    single-line-->
        <!--                    hide-details-->
        <!--                />-->
        <v-spacer/>
        <v-select
          label="Filter by driver"
          v-model="driverSelected"
          :items="drivers"
          single-line
          hide-details
          clearable
          style="width: 20px"
        />
        <v-select
          class="pl-2"
          label="Location"
          flat
          hide-details
          v-model="filterLocation"
          :items="['','home','office']"
          style="width: 20px"
        />
        <v-select
          class="pl-2"
          label="Delivery City"
          flat
          hide-details
          v-model="filterDistributionCity"
          :items="distributionCities"
          style="width: 20px"
          clearable
        />
        <v-checkbox
          class="pl-2 pt-2"
          label="UID"
          v-model="showUid"
          hide-details
        />
        <v-checkbox
          class="pl-2 pt-2"
          label="QR"
          v-model="showQRCodes"
          hide-details
        />
        <v-dialog
          v-model="showDatePicker"
          ref="dialog"
          width="290px"
          persistent
        >
          <v-date-picker
            v-model="datePickerDate"
            :range="isAdmin"
            no-title
            @close="!isAdmin && closeDatePicker()"
            @change="closeDatePicker"
          ></v-date-picker>
          <v-btn v-if="isAdmin" @click="closeDatePicker">Close</v-btn>
        </v-dialog>
      </v-toolbar>
      <div class="d-print-none my-5">
        <div class="pl-5">Filters</div>
        <v-toolbar class=" d-print-none pl-0 justify-space-between align-start" flat>
          <v-checkbox
            label="Last Bin Check"
            v-model="lastBinCheck"
            class="mr-3"
          />
          <v-checkbox
            label="With Notes"
            v-model="showNotes"
            class="mr-3"
          />
          <v-spacer/>
          <v-radio-group
            v-model="boxRackFilter"
            row
            hide-details
            class="mr-3 mb-5 border_all pa-2"
            label="Packing Filter"
          >
            <v-radio label="Box Racks Only" value="box"/>
            <v-radio label="Non-Box Racks Only" value="nonbox"/>
            <v-radio label="All" value="all"/>
          </v-radio-group>

          <v-spacer/>
          <v-select
            style="width: 100px"
            label="Exclude Tags"
            v-model="excludeTags"
            multiple
            :items="customerTags"
            clearable
            hint="Customers with these tags will be hidden below (eg, SPUD & Extras)"
            persistent-hint
          />
        </v-toolbar>
      </div>
      <template v-if="!readOnly">
        <v-toolbar flat outlined class="d-print-none" v-if="!isDelivery">
          <label>Assign orders to rack bins</label>

          <v-btn class="ml-2" :disabled="!assignBinsOpen" @click="assignBins">Assign</v-btn>
          <span v-if="!assignBinsOpen" class="ml-2 text-caption grey--text">
            Assign opens {{ assignOpensAtFormatted }}
          </span>
          <v-spacer/>
          <v-btn class="ml-2" :to="{name: 'BinDistribution', query: currentQuery}">Distribution</v-btn>
          <v-btn class="ml-2" :to="{name: 'RackAssignment'}">Rack Configuration</v-btn>
          <template v-if="isAdmin">
            <v-btn outlined @click="clearBins" color="red" class="ml-2">
              <v-icon>mdi-warning</v-icon>
              Clear
            </v-btn>
          </template>
          <v-chip
            v-if=!showUnassignedBins
            outlined
            class="ml-2" @click="showUnassignedBins=!showUnassignedBins"
            color="green"
          >
            {{ assignedOrders.length }} of
            {{ ordersFiltered.length }} are assigned
          </v-chip>
          <v-chip
            v-if=showUnassignedBins
            outlined
            class="ml-2" @click="showUnassignedBins=!showUnassignedBins"
            color="red"
          >
            {{ ordersFiltered.length - assignedOrders.length }} of
            {{ ordersFiltered.length }} are unassigned
          </v-chip>
        </v-toolbar>
        <v-dialog v-model="showLinkDialog" max-width="600px">
          <v-card>
            <v-card-title>Link Task</v-card-title>
            <v-card-text>
              This will create a link between an onfleet task and a FED order, so that ETA, driver assignment, etc, are
              shown below.
              You can use this to link manually created tasks in onfleet.
              <br/>
              {{ onfleetUid }} {{ onfleetShortId }}
              <v-text-field
                label="Onfleet ShortId"
                v-model="onfleetShortId"
                clearable
                class="mr-2"
                hint="Something like this: d588f4d4"
              />
              <v-autocomplete
                label="Link Delivery"
                v-model="onfleetUid"
                class="mr-2"
                :items="ordersByAddress"
                item-value="key"
                item-text="value"
                clearable
              />
            </v-card-text>
            <v-card-actions>
              <v-btn @click="showLinkDialog=false">Cancel</v-btn>
              <v-spacer/>
              <v-btn @click="linkTask(onfleetUid,onfleetShortId)">Link</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-toolbar flat class="d-print-none" v-if="isDelivery">
          <v-btn :disabled="!isAdmin" outlined @click="showLinkDialog=true">Link Onfleet Task</v-btn>
          <v-spacer/>
          <v-text-field
            v-if="isAdmin"
            class="ml-2"
            flat
            hide-details
            label="Override Ship Date"
            v-model="overrideShipDate"
            placeholder="use YYYY-MM-DD date format, eg 2022-12-26"
          />
          <v-btn :disabled="!isAdmin" outlined class="ml-2" :loading="exporting" @click="exportToOnfleet">Export to
            Onfleet
          </v-btn>
          <v-checkbox label="Show Errors" class="ml-2" v-model="onlyErrors" hide-details/>
        </v-toolbar>
      </template>
      <!-- everything that prints; the scale shrinks it so more fits on a page -->
      <div :style="printScaleStyle" data-cy="packing-print-content">
      <template v-if="groupBy==='bins'">
        <v-text-field
          class="d-print-none"
          v-model="binLabelFilter"
          label="Filter bin labels"
          append-icon="mdi-magnify"
          clearable
          hide-details
          single-line
        />
        <BinLabel
          v-for="(label,index) of filteredBinLabels" v-bind:key="index"
          :label="label"
          :qr-code-value="`target-bin=${label}`"
        />
      </template>
      <template v-if="groupBy==='raw'">
        <v-btn outlined @click="csvExport(rawItemsAsTable,exportFilename)">Download CSV</v-btn>
        <v-data-table
          :items="rawItems"
          :headers="rawHeaders"
        />
      </template>
      <template v-if="groupBy==='rack'">
        <v-card
          v-for="(rack,index) of racks"
          v-bind:key="rack"
          :style="index>0 ? 'page-break-before: always;':'page-break-inside: avoid;'"
          flat
        >
          <!-- the blank sheet between groups: it breaks AFTER itself, so the page it sits on
               holds only this space. A break-before here is dropped by chrome (a forced break
               at the top of a page is ignored), which lost the blank sheet in the pdf -->
          <div v-if="index>0" style="page-break-after: always">
            &nbsp;
          </div>
          <v-card-title>
            <v-spacer/>
            {{ rack }}
            <v-spacer/>
          </v-card-title>
          <v-row
            style="page-break-inside: avoid;"
            v-for="(customerOrders,customerName) of sortByBin(groupByCustomer(filterByRack(orders,rack)))"
            v-bind:key="customerName"
            :style="hasComment(customerOrders)?'border: 2px solid red':''"
          >

            <v-col cols="1" class="text-center" align-self="center" style="font-size: 40px">
              <input type="checkbox" style="width: 30px; height: 30px;">
              {{ getCount(customerOrders) }}
              <div class="d-flex flex-wrap justify-center" style="line-height: 1">
                <v-icon
                  v-for="bin of getCustomerBins(customerOrders)"
                  v-bind:key="bin"
                >{{ isBoxBin(bin) ? 'mdi-package-variant-closed' : 'mdi-shoe-sneaker' }}
                </v-icon>
              </div>
            </v-col>
            <v-col>
              <h4>
                <v-btn outlined x-small class="d-print-none" v-if="customerOrders[0].customer.uid"
                       :to="{name:'Customer',params:{id:customerOrders[0].customer.uid}}" target="_blank">
                  Edit Customer
                </v-btn>
                {{ customerName }}
                <template v-if="hasLastBinCheck(customerOrders)">
                  <span class="d-print-none"> (last bin check) </span>
                </template>
                <template v-if="getCount(customerOrders)>0">
                  - {{ getCount(customerOrders) }} items
                  -
                  {{ getCustomerLocations(customerOrders).join(',') }}
                  delivery on
                  <span
                    v-for="(date,index) of getCustomerDeliveryDates(customerOrders)"
                    v-bind:key="date"
                  ><template v-if="index!==0">,</template> {{ dateFormatted(date) }}</span>

                  <span v-if="customerOrders[0].eta">
                    @ {{ dateFormatted(customerOrders[0].eta, {formatString: 'h:mma'}) }}
                  </span>

                  <span v-if="isFirstOrder(customerOrders[0])">
                    😃
                    <input type="checkbox" style="width: 20px; height: 20px;"/>
                  </span>
                  <span class="pl-4 red--text" v-if="hasComment(customerOrders)">
                    <div v-for="(comment,i) of hasComment(customerOrders)" v-bind:key="i">
                      <input type="checkbox" style="width: 20px; height: 20px;"/>
                      {{ comment }}
                    </div>
                  </span>
                </template>

              </h4>
              <ul v-if="isDelivery">
                <li v-for="(s,index) of getDeliveryStatus(customerOrders)" v-bind:key="index">
                  {{ s.day }} : {{ s.status }}
                  <v-alert type="error" v-if="s.error">{{ s.error }}</v-alert>
                  <!--                    <br/>-->
                  <!--                    {{ s }}-->
                </li>
              </ul>

              <template v-if="getCount(customerOrders)>0">
                <div v-for="(order,index) of customerOrders" v-bind:key="index">
                  <v-chip
                    x-small outlined
                    :label="isBoxBin(bin)"
                    v-for="bin of (order.bin || '?').split(',')"
                    v-bind:key="bin"
                  >
                    {{ bin }}
                  </v-chip>
                  <span :class="order.tod==='extras'?'font-weight-bold':''">
                      {{ order.quantity }}
                      - <span style="display: inline-block; min-width: 65px">{{ order.tod }}</span>
                      - ({{ order.stream }}, {{ order.meal_size }})
                      - <span style="display: inline-block; min-width: 35px">{{
                      dateFormatted(order.date, {formatString: 'ddd'})
                    }}</span>
                      - {{ order.mealName }}
                      </span>
                  <v-chip v-for="a of order.displayAllergies" v-bind:key="a" x-small outlined class="pa-2 ml-1">{{
                      a
                    }}
                  </v-chip>
                  <v-chip small outlined color="red" v-if="order.donate">
                    DONATE | DO NOT SHIP
                  </v-chip>
                </div>
              </template>
            </v-col>
            <v-col cols="2" class="text-center" align-self="center">
              <!--                <span v-if="isFirstOrder(customerOrders[0])">-->
              <!--                    😃-->
              <!--                    <input type="checkbox" style="width: 20px; height: 20px;"/>-->
              <!--                  </span>-->
              <!--                <span class="pl-4 red&#45;&#45;text" v-if="hasComment(customerOrders)">-->
              <!--                    <div v-for="(comment,i) of hasComment(customerOrders)" v-bind:key="i">-->
              <!--                      <input type="checkbox" style="width: 20px; height: 20px;"/>-->
              <!--                      {{ comment }}-->
              <!--                    </div>-->
              <!--                  </span>-->

              <template v-if="getCount(filterByTod(customerOrders, 'extras', true))>0">
                <div style="font-size: 40px">
                  <input type="checkbox" style="width: 30px; height: 30px;"/>
                  {{ getCount(filterByTod(customerOrders, 'extras', true)) }}
                </div>
                <br/>
                extras
              </template>
              <p style="color: red; font-weight: bolder" v-if="isFirstOrder(customerOrders[0])">
                  <span style="font-size: 35px">
                    <input type="checkbox" style="width: 30px; height: 30px;"/>😃
                  </span>
                <br/>new cust. pack
              </p>
            </v-col>
          </v-row>
        </v-card>
      </template>
      <template v-if="groupBy==='customer' || groupBy==='meal'">
        <v-card
          :style="index < driversFiltered.length - 1 ? 'page-break-after: always;' : ''"
          flat
          v-for="(driver,index) of driversFiltered"
          v-bind:key="driver"
        >
          <!-- the blank sheet between groups: it breaks AFTER itself, so the page it sits on
               holds only this space. A break-before here is dropped by chrome (a forced break
               at the top of a page is ignored), which lost the blank sheet in the pdf -->
          <div v-if="index>0" style="page-break-after: always">
            &nbsp;
          </div>
          <v-card-title>
            Driver: {{ driver }}
            <v-spacer/>
            <div
              style="font-size: .7em; border: 1px solid black; border-radius: 10px; padding-left: 5px; padding-right: 5px;">
              <v-icon>mdi-printer</v-icon>
              {{ pageLoadedDate.toLocaleTimeString() }} {{ pageLoadedDate.toLocaleDateString() }}
            </div>
          </v-card-title>
          <template v-if="groupBy==='customer'">
            <v-row
              style="page-break-inside: avoid;"
              v-for="(customerOrders,customerName,customerIndex) of groupByCustomer(orders.filter(o => o.driver === driver))"
              v-bind:key="customerName"
              :style="hasComment(customerOrders)?'border: 2px solid red':''"
            >
              <v-col cols="1" class="text-center" align-self="center" style="font-size: 40px">
                <input type="checkbox" style="width: 30px; height: 30px;">
                {{ getCount(customerOrders) }}
                <div class="d-flex flex-wrap justify-center" style="line-height: 1">
                  <v-icon
                    v-for="bin of getCustomerBins(customerOrders)"
                    v-bind:key="bin"
                  >{{ isBoxBin(bin) ? 'mdi-package-variant-closed' : 'mdi-shoe-sneaker' }}
                  </v-icon>
                </div>
              </v-col>
              <v-col>
                <h4>
                  <v-btn outlined x-small class="d-print-none" v-if="customerOrders[0].customer.uid"
                         :to="{name:'Customer',params:{id:customerOrders[0].customer.uid}}" target="_blank">
                    Edit Customer
                  </v-btn>
                  [{{ String(index + 1).padStart(2, '0') }}-{{ String(customerIndex + 1).padStart(3, '0') }}]
                  {{ customerName }}
                  <template v-if="hasLastBinCheck(customerOrders)">
                    <span class="d-print-none"> (last bin check) </span>
                  </template>
                  <template v-if="getCount(customerOrders)>0">
                    - {{ getCount(customerOrders) }} items
                    -
                    {{ getCustomerLocations(customerOrders).join(',') }}
                    delivery
                    on
                    <span
                      v-for="(date,index) of getCustomerDeliveryDates(customerOrders)"
                      v-bind:key="date"
                    ><template v-if="index!==0">,</template> {{ dateFormatted(date) }}</span>

                    <span v-if="customerOrders[0].eta">
                    @ {{ dateFormatted(customerOrders[0].eta, {formatString: 'h:mma'}) }}
                  </span>
                    <span
                      v-if="getDistributionCity(customerOrders).join(',')!=='vancouver'"
                      style="text-transform: lowercase; color: red; font-weight: bolder">
                      [{{ getDistributionCity(customerOrders).join(',') }}]
                    </span>

                    <span v-if="isFirstOrder(customerOrders[0])">
                    😃
                    <input type="checkbox" style="width: 20px; height: 20px;"/>
                  </span>
                    <span class="pl-4 red--text" v-if="hasComment(customerOrders)">
                    <div v-for="(comment,i) of hasComment(customerOrders)" v-bind:key="i">
                      <input type="checkbox" style="width: 20px; height: 20px;"/>
                      {{ comment }}
                    </div>
                  </span>
                  </template>

                </h4>
                <ul v-if="isDelivery">
                  <li v-for="(s,index) of getDeliveryStatus(customerOrders)" v-bind:key="index">
                    {{ s.day }} : {{ s.status }}
                    <v-alert type="error" v-if="s.error">{{ s.error }}</v-alert>
                    <!--                    <br/>-->
                    <!--                    {{ s }}-->
                  </li>
                </ul>

                <template v-if="getCount(customerOrders)>0">
                  <div class="d-flex my-1 align-center" v-for="(order,index) of customerOrders" v-bind:key="index">
                    <v-chip
                      x-small outlined
                      :label="isBoxBin(bin)"
                      v-for="bin of (order.bin || '?').split(',')"
                      v-bind:key="bin"
                    >
                      {{ bin }}
                    </v-chip>
                    <span :class="order.tod==='extras'?'font-weight-bold':''">
                      {{ order.quantity }}
                      - <span style="display: inline-block; min-width: 65px">{{ order.tod }}</span>
                      - ({{ order.stream }}, {{ order.meal_size }}<span
                      v-if="order.containerSize!==undefined">, {{ order.containerSize }} container</span>)
                      - <span style="display: inline-block; min-width: 35px">{{
                        dateFormatted(order.date, {formatString: 'ddd'})
                      }}</span>
                      - {{ order.mealName }}
                      </span>
                    <v-chip v-for="a of order.displayAllergies" v-bind:key="a" x-small outlined class="pa-2 ml-1">{{
                        a
                      }}
                    </v-chip>
                    <v-spacer/>
                    <v-chip small outlined color="red" v-if="order.donate">
                      DONATE | DO NOT SHIP
                    </v-chip>
                  </div>
                </template>

              </v-col>
              <v-col cols="2" class="text-center" align-self="center">
                <!--                <span v-if="isFirstOrder(customerOrders[0])">-->
                <!--                    😃-->
                <!--                    <input type="checkbox" style="width: 20px; height: 20px;"/>-->
                <!--                  </span>-->
                <!--                <span class="pl-4 red&#45;&#45;text" v-if="hasComment(customerOrders)">-->
                <!--                    <div v-for="(comment,i) of hasComment(customerOrders)" v-bind:key="i">-->
                <!--                      <input type="checkbox" style="width: 20px; height: 20px;"/>-->
                <!--                      {{ comment }}-->
                <!--                    </div>-->
                <!--                  </span>-->

                <template v-if="getCount(filterByTod(customerOrders, 'extras', true))>0">
                  <div style="font-size: 40px">
                    <input type="checkbox" style="width: 30px; height: 30px;"/>
                    {{ getCount(filterByTod(customerOrders, 'extras', true)) }}
                  </div>
                  <br/>
                  extras
                </template>
                <p style="color: red; font-weight: bolder" v-if="isFirstOrder(customerOrders[0])">
                  <span style="font-size: 35px">
                    <input type="checkbox" style="width: 30px; height: 30px;"/>😃
                  </span>
                  <br/>new cust. pack
                </p>
              </v-col>
            </v-row>
          </template>
          <template v-if="groupBy==='meal'">
            <v-card-text
              v-for="(mealOrders,mealName) of groupByMeal(orders.filter(o => o.driver === driver))"
              v-bind:key="mealName">
              <h4>{{ mealName }} - Meal Count {{ getCount(mealOrders) }}</h4>
              <ul>
                <li v-for="(order,index) of sortBySize(mealOrders)" v-bind:key="index">
                  <v-chip
                    x-small outlined
                    :label="isBoxBin(bin)"
                    v-for="bin of (order.bin || '?').split(',')"
                    v-bind:key="bin"
                  >
                    <v-icon small left>{{ isBoxBin(bin) ? 'mdi-package-variant-closed' : 'mdi-shoe-sneaker' }}</v-icon>
                    {{ bin }}
                  </v-chip>
                  {{ order.quantity }} - {{ order.tod }} - {{ order.name }}
                  ({{ order.meal_size }}) - {{ dateFormatted(order.date) }}
                  <span v-for="a of order.displayAllergies" v-bind:key="a">
                    <v-chip x-small outlined class="pa-2">{{ a }}</v-chip>
                  </span>
                </li>
              </ul>
            </v-card-text>
          </template>
        </v-card>
      </template>
      <template v-if="groupBy==='none'">
        <v-card-text
          v-for="(mealOrders,mealName) of groupByMeal(orders)"
          v-bind:key="mealName">
          <h4>{{ mealName }} - Meal Count {{ getCount(mealOrders) }}</h4>
          <ul>
            <li v-for="(order,index) of sortBySize(mealOrders)" v-bind:key="index">
              <v-chip
                x-small outlined
                :label="isBoxBin(bin)"
                v-for="bin of (order.bin || '?').split(',')"
                v-bind:key="bin"
              >
                <v-icon small left>{{ isBoxBin(bin) ? 'mdi-package-variant-closed' : 'mdi-shoe-sneaker' }}</v-icon>
                {{ bin }}
              </v-chip>
              {{ order.quantity }} - {{ order.tod }} - {{ order.name }}
              ({{ order.meal_size }})
              - {{ dateFormatted(order.date) }}
              <span
                v-for="a of order.displayAllergies" v-bind:key="a">
                  <v-chip x-small outlined class="pa-2">{{ a }}</v-chip>
                </span>
              - Driver: {{ order.driver }}
            </li>
          </ul>
        </v-card-text>
      </template>
      <template v-if="groupBy==='bag'">
        <v-container fluid class="pa-0">
          <v-toolbar class="d-print-none">
            <v-spacer/>
            <v-btn-toggle v-model="bagStickerSelector">
              <v-btn value="box">Box Rack</v-btn>
              <v-btn value="regular">Regular Rack</v-btn>
              <v-btn value="all">All Racks</v-btn>
            </v-btn-toggle>
            <v-spacer/>
            <v-btn
              outlined
              :color="hasAdvancedBagOptions ? 'primary' : undefined"
              @click="showAdvancedBagOptions = !showAdvancedBagOptions">
              Advanced
              <v-icon right>{{ showAdvancedBagOptions ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </v-toolbar>
          <v-toolbar v-if="showAdvancedBagOptions" class="d-print-none">
            <v-text-field
              v-model="bagLabelFilter"
              style="max-width: 260px"
              label="Filter (name, driver, bin, address)"
              append-icon="mdi-magnify"
              clearable
              hide-details
              single-line
            />
            <!-- meal count bounds, matched together with the text above and
                 kept or dropped by the same show/hide toggle -->
            <v-text-field
              class="ml-4"
              style="max-width: 110px"
              type="number"
              min="0"
              dense
              hide-details
              clearable
              label="Meals from"
              v-model="bagLabelMealsMin"
            />
            <v-text-field
              class="ml-2"
              style="max-width: 110px"
              type="number"
              min="0"
              dense
              hide-details
              clearable
              label="Meals to"
              v-model="bagLabelMealsMax"
            />
            <v-btn-toggle v-model="bagLabelFilterMode" mandatory class="ml-4">
              <v-btn value="include">Show matching</v-btn>
              <v-btn value="exclude">Hide matching</v-btn>
            </v-btn-toggle>
            <v-text-field
              class="ml-8"
              style="max-width: 120px"
              type="number"
              min="1"
              step="0.5"
              dense
              hide-details
              label="Multiply stickers"
              suffix="x"
              :value="bagStickerMultiplier"
              @change="setStickerMultiplier($event)"
            />
            <v-btn
              outlined class="ml-4"
              :disabled="!hasStickerOverrides"
              @click="clearAllStickerOverrides">
              Reset overrides
            </v-btn>
          </v-toolbar>
          <div v-for="(bag,index) of bags" v-bind:key="`driver-${index}-${bag.driver}`"
               class="fed-bag-sheet" style="border: dotted black 1px">
            <BagDriverLabel
              v-if="bag.isDriverLabel"
              :driver="bag.driver"
              :bag-count="bag.count"
            />
            <template v-if="!bag.isDriverLabel">
              <div v-if="showAdvancedBagOptions" class="d-print-none pa-2 d-flex align-center">
                <span>
                  {{ bag.customerName }} — {{ bag.mealCount }} meals, bag calc says {{ bag.bagCalcCount }}
                  <template v-if="bag.calculatedCount !== bag.bagCalcCount">
                    × {{ bagStickerMultiplier }} = {{ bag.calculatedCount }}
                  </template>
                </span>
                <v-text-field
                  class="ml-4"
                  style="max-width: 100px"
                  type="number"
                  min="1"
                  dense
                  hide-details
                  label="Stickers"
                  :value="bag.count"
                  @change="setStickerOverride(bag.customerName, $event)"
                />
                <v-btn
                  v-if="bag.count !== bag.calculatedCount"
                  small text class="ml-2"
                  @click="clearStickerOverride(bag.customerName)">Reset
                </v-btn>
              </div>
              <div
                v-for="i of range(1,bag.count+1)"
                v-bind:key="`${index}-${i}-${showQRCodes}-${bag.driver}`">
                <!--                <div class="d-print-none ma-4" v-if="bag.eta">-->
                <!--                  <hr/>-->
                <!--                  <h1>{{ dateFormatted(bag.eta, {formatString: 'h:mma'}) }}</h1>-->
                <!--                </div>-->
                <BagLabel
                  v-if="showQRCodes"
                  :driver="bag.driver"
                  :sequence="bag.sequence"
                  :customer-name="bag.customerName"
                  :bag="i"
                  :eta="bag.eta"
                  :bags="bag.count"
                  :bag-size="bag.bagSize"
                  :bins="binsForSticker(bag, i)"
                  :qr-code-value="qrCodeForSticker(bag, i)"
                  :address_line_1="bag.address_line_1"
                  :address_line_2="bag.address_line_2"
                />
                <BagLabel
                  v-if="!showQRCodes"
                  :driver="bag.driver"
                  :sequence="bag.sequence"
                  :customer-name="bag.customerName"
                  :bag="i"
                  :eta="bag.eta"
                  :bags="bag.count"
                  :bag-size="bag.bagSize"
                  :bins="binsForSticker(bag, i)"
                  :address_line_1="bag.address_line_1"
                  :address_line_2="bag.address_line_2"
                />
              </div>
            </template>
          </div>
        </v-container>
      </template>
      <template v-if="groupBy==='shippingLabel'">
        <v-card v-for="(orders,uid) of  shipments" v-bind:key="uid">
          <v-card-title>
            <router-link :to="{name:'Customer',params:{id:uid}}">{{ getCustomerName(uid) }}</router-link>
            ({{ getCustomer(uid).plan }}) :: {{ orders.reduce((sum, o) => o.quantity + sum, 0) }} meals
          </v-card-title>
          <v-card-text>
            <v-chip outlined>{{ getCustomer(uid).address.location }}</v-chip>
            {{ getCustomerName(uid) }}, {{ formatAddress(getCustomer(uid).address) }}
            <v-btn icon class="d-print-none"
                   @click="copyToClipboard(`${ getCustomerName(uid) }, ${ formatAddress(getCustomer(uid).address) }`)">
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </v-card-text>
          <v-card-text>
            <div v-for="(order,index) of orders" v-bind:key="index">
              <v-chip
                x-small outlined
                :label="isBoxBin(bin)"
                v-for="bin of (order.bin || '?').split(',')"
                v-bind:key="bin"
              >
                <v-icon small left>{{ isBoxBin(bin) ? 'mdi-package-variant-closed' : 'mdi-shoe-sneaker' }}</v-icon>
                {{ bin }}
              </v-chip>
              <span :class="order.tod==='extras'?'font-weight-bold':''">
                      {{ order.quantity }}
                      - <span style="display: inline-block; min-width: 65px">{{ order.tod }}</span>
                      - ({{ order.stream }}, {{ order.meal_size }})
                      - <span style="display: inline-block; min-width: 35px">{{
                  dateFormatted(order.date, {formatString: 'ddd'})
                }}</span>
                      - {{ order.mealName }}
                      </span>
              <v-chip v-for="a of order.displayAllergies" v-bind:key="a" x-small outlined class="pa-2 ml-1">{{
                  a
                }}
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </template>
      <template v-if="groupBy==='deliveryList'">
        <v-card
          :style="index < driversFiltered.length - 1 ? 'page-break-after: always;' : ''"
          flat
          v-for="(driver,index) of driversFiltered"
          v-bind:key="driver"
        >
          <v-card-title>
            Driver: {{ driver }}
          </v-card-title>
          <template>
            <v-row
              style="page-break-inside: avoid;"
              v-for="(customerOrders,customerName) of groupByCustomer(orders.filter(o => o.driver === driver))"
              v-bind:key="customerName"
            >
              <v-col cols="1" class="text-center" align-self="center" style="font-size: 40px">
                <input type="checkbox" style="width: 30px; height: 30px;">
                {{ getBagCount(customerOrders) }}
              </v-col>
              <v-col cols="3">
                <div class="font-weight-bold">{{ formatAddress(customerOrders[0].customer.address) }}</div>
                <div>
                  {{ customerName }} - {{ getCount(customerOrders) }} meals
                  -
                  <span
                    v-for="(date,index) of getCustomerDeliveryDates(customerOrders)"
                    v-bind:key="date"
                  ><template v-if="index!==0">,</template> {{
                      dateFormatted(date, {formatString: 'ddd MMM DD'})
                    }}</span>

                  <span v-if="customerOrders[0].eta">
                    @ {{ dateFormatted(customerOrders[0].eta, {formatString: 'h:mma'}) }}
                  </span>
                  <!--                  {{ customerOrders[0].uid }}-->
                  <span v-if="isFirstOrder(customerOrders[0])">
                    😃
                    <input type="checkbox" style="width: 20px; height: 20px;"/>
                  </span>
                </div>
                <div style="font-size: small"
                     v-if="getDeliveryInstruction(customerOrders[0].customer, customerOrders[0].date)">
                  <b>Note:</b> {{ getDeliveryInstruction(customerOrders[0].customer, customerOrders[0].date) }}
                </div>
              </v-col>
            </v-row>
          </template>
        </v-card>
      </template>
      </div>
      <!-- blank gap at the bottom to avoid fixed footer hiding data-table -->
      <div class="ma-8 packing-bottom-gap"></div>
    </div>
  </v-container>
</template>


<script>
import {mapActions, mapGetters} from 'vuex'
import dayjs from 'dayjs';
import {csvExport, dateFormatted, getProductionDays} from '@/store/utils'
import api from '@/api';
import BagLabel from "@/components/BagLabel";
import BagCalc from "@/store/bag-calc";
import CustomerLookup from "@/store/customer-lookup";
import {range} from "lodash";
import BagDriverLabel from "@/components/BagDriverLabel";
import urlState from "@/router/urlState";
import DebouncedTextField from "@/components/DebouncedTextField.vue";
import BinLabel from "@/components/BinLabel.vue";
import ShippingGroupSelector from "@/components/ShippingGroupSelector.vue";
import diff from "microdiff";
import {formatAddress, getDeliveryInstruction} from "../store/utils";
import {checkAssignBinsOpen, getAssignBinsDeadline} from "fed-lib/src/assign-deadline";
import {claimPrintPage, releasePrintPage} from "@/utils/print-page";
import {PRINT_SCALE_RANGE, printScaleFromUrl, rejectedPrintScale} from "@/utils/print-scale";

// the box sticker (BagLabel .full-page-portrait) as a print page of its own: one per sheet, no
// margins. On that paper anything past a sticker's edge is a blank sheet: the sheet's dotted
// screen border, a forced break after the last sticker (each breaks before itself instead;
// chrome adds no page for a break at the very start) and the page's bottom gap
const STICKER_PRINT_PAGE = 'size: 7.6cm 12.5cm; margin: 0';
const STICKER_PRINT_CSS = `@media print {
  .fed-bag-sheet { border: none !important; }
  .fed-bag-sheet .page-break { page-break-after: auto !important; page-break-before: always !important; }
  .packing-bottom-gap { display: none !important; }
}`;


// The only customer fields this view reads that are not already embedded in the
// order-search snapshot are comment/customer_notes (hasComment) and
// useAddress/delivery_instruction (getDeliveryInstruction). The rest round out
// getCustomer() usage (shipping labels, locations, names) so scoped lookups can
// fully replace the whole-directory fetchCustomers.
const CUSTOMER_FIELDS = [
  'uid', 'first_name', 'last_name', 'email', 'plan', 'tags', 'last_bin_check',
  'comment', 'customer_notes', 'delivery_instruction', 'useAddress', 'address',
];
const customerLookup = new CustomerLookup(CUSTOMER_FIELDS);

// Debug mode: only log to the console when running locally (eg. localhost / 127.0.0.1).
// In production the logs are suppressed to avoid the cost of logging large arrays on hot paths.
const isDebug = typeof window !== 'undefined'
  && ['localhost', '127.0.0.1'].includes(window.location.hostname);
const debug = (...args) => {
  // eslint-disable-next-line no-console
  if (isDebug) console.log(...args);
};

function isBoxBin(bin) {
  return bin && BagCalc.isBoxBinName(bin);
}

export default {
  components: {ShippingGroupSelector, BinLabel, BagDriverLabel, BagLabel, DebouncedTextField},
  mixins: [urlState],
  data() {
    return {
      units: ['g', 'kg'],
      decimalPlaces: [1, 2],
      streamsSelected: [],
      driverSelected: null,
      selected: [],
      missing_meals: new Set(),
      missing_count: {},
      showDatePicker: false,
      dates: [],
      search: '',
      loading: true,
      post: null,
      error: null,
      multiview: false,
      multiviewMealSelected: {},
      headers: [
        // {
        //   text: 'Email',
        //   align: 'start',
        //   value: 'email',
        //   width: '*'
        // },
        {text: 'Driver', value: 'driver'},
        {text: 'Customer Name', value: 'name',},
        {text: 'Quantity', value: 'quantity'},
        // {text: 'Meal ID', value: 'meal_id'},
        {text: 'Meal', value: 'mealName'},
        {text: 'Stream', value: 'stream'},
        {text: 'Allergy/Restrictions', value: 'displayAllergies',},

        {text: 'Time of day', value: 'tod'},
        {text: 'Date', value: 'date'}

      ],
      showMissing: false,
      filteredIngredients: [],
      maxEmailPerLink: 450,
      groupBy: 'customer',
      // shrinks the printed content (css zoom) so more fits on a page; kept in the url as ?scale=
      printScale: 1,
      printScaleRange: PRINT_SCALE_RANGE,
      // what was typed into the scale field when it could not be used, while the dialog explains
      printScaleRejected: null,
      showAssignInProgress: null,
      showClearInProgress: null,
      datePickerDate: null,
      filterLocation: null,
      filterDistributionCity: null,
      exporting: null,
      overrideShipDate: '',
      onlyErrors: false,
      showUid: false,
      showExportDialog: null,
      exportStatus: {},
      onfleetShortId: '',
      showLinkDialog: false,
      onfleetUid: '',
      showQRCodes: true,
      excludeTags: [],
      binLabels: [],
      binLabelFilter: '',
      lastBinCheck: false,
      showNotes: false,
      driverTasks: [],
      bagStickerSelector: 'regular',
      bagLabelFilter: '',
      // meal count bounds for the bag label filter, blank meaning unbounded
      bagLabelMealsMin: '',
      bagLabelMealsMax: '',
      bagLabelFilterMode: 'include',
      // multiplies every bag calc count, eg 2 to print two stickers per box
      bagStickerMultiplier: 1,
      showAdvancedBagOptions: false,
      // keyed by customer name, holds a manual sticker count that replaces the
      // bag calc result for this print run only (QR codes are left untouched).
      stickerOverrides: {},
      boxRackFilter: 'all',
      rackConfigs: [],
      shippingGroup: null,
      ordersFetched: [],
      customers: {},
      showUnassignedBins: false,
      pageLoadedDate: new Date(),
      now: Date.now(),
      nowTimer: null,
    }
  },
  async mounted() {

    this.syncToUrl({
      param: 'filterDistributionCity', urlParam: 'city', initFromRoute: true,
      // parseCallback: (v) => v === 'true'
    });
    this.syncToUrl({
      param: 'filterLocation', urlParam: 'location', initFromRoute: true,
      // parseCallback: (v) => v === 'true'
    });
    this.syncToUrl({
      param: 'binLabelFilter', urlParam: 'bin_label_filter', initFromRoute: true,
      // parseCallback: (v) => v === 'true'
    });
    this.syncToUrl({
      param: 'search', urlParam: 'search', initFromRoute: true,
      // parseCallback: (v) => v === 'true'
    });
    this.syncToUrl({
      param: 'dates', urlParam: 'dates', initFromRoute: true,
      parseCallback: (v) => Array.isArray(v) ? v : [v]
    });
    this.syncToUrl({
      param: 'shippingGroup', urlParam: 'shippinggroup', initFromRoute: true,
    });
    this.syncToUrl({
      param: 'driverSelected', urlParam: 'driver', initFromRoute: true,
      // parseCallback: (v) => v === 'true'
    });
    this.syncToUrl({
      param: 'groupBy', urlParam: 'group', initFromRoute: true,
      // parseCallback: (v) => v === 'true'
    });
    this.syncToUrl({
      param: 'bagStickerSelector', urlParam: 'rack', initFromRoute: true,
      // parseCallback: (v) => v === 'true'
    });
    this.syncToUrl({
      param: 'bagLabelFilter', urlParam: 'bag_label_filter', initFromRoute: true,
    });
    this.syncToUrl({
      param: 'printScale', urlParam: 'scale', initFromRoute: true,
      parseCallback: printScaleFromUrl,
      transformCallback: (v) => v === 1 ? null : v
    });
    this.syncToUrl({
      param: 'bagLabelMealsMin', urlParam: 'bag_label_meals_min', initFromRoute: true,
    });
    this.syncToUrl({
      param: 'bagLabelMealsMax', urlParam: 'bag_label_meals_max', initFromRoute: true,
    });
    this.syncToUrl({
      param: 'bagLabelFilterMode', urlParam: 'bag_label_mode', initFromRoute: true,
    });
    this.syncToUrl({
      param: 'bagStickerMultiplier', urlParam: 'sticker_multiplier', initFromRoute: true,
      parseCallback: (v) => Number(v) || 1
    });
    this.syncToUrl({
      param: 'onlyErrors', urlParam: 'errors', initFromRoute: true,
      parseCallback: (v) => v === 'true'
    });
    // this.syncToUrl({
    //   param: 'lastBinCheck', urlParam: 'last_bin_check', initFromRoute: true,
    //   parseCallback: (v) => v === 'true'
    // });
    this.syncToUrl({
      param: 'showQRCodes', urlParam: 'qr', initFromRoute: true,
      parseCallback: (v) => v === 'true'
    });

    const params = ['lastBinCheck', 'showNotes'];
    params.forEach(param => {
      this.syncToUrl({
        param, urlParam: param, initFromRoute: true,
        parseCallback: (v) => v === 'true'
      })
    })

    this.syncToUrl({
      param: 'boxRackFilter', urlParam: 'boxRackFilter', initFromRoute: true,
    })

    this.excludeTags = ['DoNotPrint'];
    this.setDates();
    // keep "now" fresh so the assign button enables without a reload
    this.nowTimer = setInterval(() => this.now = Date.now(), 60 * 1000);
    await this.fetchData();
    api.get('v2/order/bins').then(r => {
      debug('bin labels', r.data);
      this.binLabels = r.data;
    })
    api.get('v2/order/rack-configs')
      .then(r => this.rackConfigs = r.data)
      .catch(e => console.error('failed to load rack configs', e));
  },
  beforeDestroy() {
    clearInterval(this.nowTimer);
    releasePrintPage('packing-stickers');
  },
  watch: {
    printScale(value) {
      const rejected = rejectedPrintScale(value);
      if (rejected !== null) {
        this.printScaleRejected = rejected;
        this.printScale = 1;
      }
    },
    dates: 'fetchData',
    shippingGroup: 'fetchData',
    // the box stickers print on sticker sized pages; every other tab on the printer's default
    groupBy: {
      immediate: true,
      handler(groupBy) {
        if (groupBy === 'bag') {
          claimPrintPage('packing-stickers', STICKER_PRINT_PAGE, STICKER_PRINT_CSS);
        } else {
          releasePrintPage('packing-stickers');
        }
      },
    },
    showDatePicker(v) {
      if (v) {
        if (this.isAdmin) {
          this.datePickerDate = this.dates;
        } else {
          this.datePickerDate = this.dates[0];
        }
      } else {
        if (this.isAdmin) {
          this.dates = this.datePickerDate;
        } else {
          this.dates = getProductionDays(this.datePickerDate);
        }
      }
    },
  },
  computed: {
    printScaleStyle() {
      const scale = this.printScale > 0 ? this.printScale : 1;
      return scale === 1 ? {} : {zoom: scale};
    },
    ...mapGetters([
      'meals',
      'diets',
      'getMeal',
      'getMealIngredients',
      'getDietName',
      'getDietStream',
      'getTimeOfDay',
      'getSummaryForDiet',
    ]),
    hasStickerOverrides() {
      return Number(this.bagStickerMultiplier) !== 1
        || Object.keys(this.stickerOverrides).length > 0;
    },
    // flags the collapsed Advanced panel when something in it is changing the print
    hasAdvancedBagOptions() {
      return !!(this.bagLabelFilter || '').trim()
        || this.parseMealBound(this.bagLabelMealsMin) !== null
        || this.parseMealBound(this.bagLabelMealsMax) !== null
        || this.hasStickerOverrides;
    },
    filteredBinLabels() {
      const q = (this.binLabelFilter || '').trim().toLowerCase();
      if (!q) return this.binLabels;
      return this.binLabels.filter(label => (label || '').toLowerCase().includes(q));
    },
    readOnly() {
      return !!this.$route.meta.readOnly;
    },
    isFiltered() {
      const allOrders = this.ordersUnfiltered.length;
      const displayedOrders = this.ordersFiltered.length;
      // debug('is fitlered', {allOrders, displayedOrders});
      return allOrders !== displayedOrders;
    },
    ordersByAddress() {
      // debug('orders', this.orders);
      const result = {};
      this.orders.forEach(o => {
        const {customer = {}} = o;
        const {address = {}} = customer;
        const display = [customer.first_name, customer.last_name, address.unit || '', address.line1, address.postal_code].join(' ');
        result[o.uid] = display
      })
      return Object.entries(result)
        .map(([key, value]) => ({key, value}));
    },

    ordersUnfiltered() {
      // Enrich the fetched orders in place. Note: we must NOT push into this.ordersFetched
      // here — doing so mutates a reactive dependency of this computed, which re-triggers it
      // and grows the array unbounded on every render. Faux orders are built separately and
      // concatenated into the returned array instead.
      const orders = this.ordersFetched;
      // orders.forEach(o => o.name = `${o.last_name}, ${o.first_name}`);
      orders.forEach(o => o.name = `${o.first_name} ${o.last_name}`);
      orders.forEach(o => o.mealName = this.getMeal(o.meal_id) && this.getMeal(o.meal_id).name);
      orders.forEach(o => o.customer = this.getCustomer(o.uid));
      orders.forEach(o => o.email = o.customer ? o.customer.email : '');
      orders.forEach(o => o.driver = o.driver || 'Unassigned');
      orders.forEach(o => o.addressFormatted = formatAddress(o.address));
      const ship_dates = [...new Set(orders.map(o => o.ship_date))];
      const fauxOrders = this.driverTasks
        .filter(dt => dt.task.name === 'fed')
        .filter(dt => ship_dates.includes(dayjs(dt.task.eta).format('YYYY-MM-DD')))
        .map(dt => {
          const task = dt.task;
          const taskAddress = task.address;
          const address = {
            unit: taskAddress.apartment || '',
            state: 'British Columbia',
            postal_code: taskAddress.postalCode || '', //: 'V6A 2M9',
            line1: `${taskAddress.number} ${taskAddress.street}`,
            city: taskAddress.city || '', // : 'Vancouver',
            country: taskAddress.country || '', //: 'Canada'
            delivery_instruction: task.notes
          }
          const name = (dt.task.name === 'fed')
            ? 'RETURN TO FED FOR NEXT RUN'
            : dt.task.name + ' (onfleet)';
          const fauxOrder = {
            isOnfleetTask: true,
            shortId: task.shortId,
            eta: task.eta,
            name,
            driver: dt.worker.name,
            customer: {
              address,
            },
            address,
            quantity: 0
          };
          debug('adding faux order', fauxOrder);
          return fauxOrder;
        });
      return [...orders, ...fauxOrders];
    },
    ordersFiltered() {
      let orders = this.ordersUnfiltered;
      // debug('orders', orders);
      // const streamsSelected = this.streamsSelected;
      if (this.driverSelected) {
        orders = orders.filter(o => o.driver === this.driverSelected);
      }


      if (this.onlyErrors) {
        orders = orders.filter(o => {
          const [deliveryStatus = {}] = this.getDeliveryStatus([o]);
          return !!deliveryStatus.error;
        });
      }

      if (this.filterLocation) {
        orders = orders.filter(o => o.customer.address.location === this.filterLocation);
      }

      if (this.filterDistributionCity) {
        orders = orders.filter(o => this.filterDistributionCity.includes(o.distributionCity));
      }

      if (this.excludeTags && this.excludeTags.length > 0) {
        orders = orders.filter(o => !o.customer || !(o.customer.tags && o.customer.tags.some(tag => this.excludeTags.includes(tag))));
      }

      if (this.lastBinCheck) {
        orders = orders.filter(o => o.customer.last_bin_check);
      }
      if (this.showNotes) {
        orders = orders.filter(this.hasComment);
      }
      if (this.boxRackFilter === 'box') {
        orders = orders.filter(o => isBoxBin(o.bin));
      } else if (this.boxRackFilter === 'nonbox') {
        orders = orders.filter(o => !isBoxBin(o.bin));
      }
      return orders;
    },
    orders() {
      // used to do fruit cup stuff here
      let orders = this.ordersFiltered;
      if (this.showUnassignedBins) {
        orders = orders.filter(o => !o.bin);
      }
      return orders;
    },
    totalCount() {
      let count = 0;
      this.orders.forEach(o => count += o.quantity);
      return count;
    },
    mealsByDiet() {
      debug('this.getMealsByDiet(this.date)', this.getMealsByDiet(this.date));
      return this.getMealsByDiet(this.date);
    },
    summary() {
      return this.$store.getters.summary(this.date);
    },
    drivers() {
      const drivers = new Set();
      this.ordersUnfiltered.forEach(o => drivers.add(o.driver));
      const sortedDrivers = [...drivers.values()].filter(d => !!d).sort();
      debug('drivers', sortedDrivers);
      return sortedDrivers;
    },
    datesFormatted() {
      const format = 'dddd MMMM D';
      if (!this.dateFrom) {
        return '';
      } else if (this.dateFrom === this.dateTo) {
        return `${dayjs(this.dateFrom).format(format)}`;
      } else {
        return `${dayjs(this.dateFrom).format(format)} - ${dayjs(this.dateTo).format(format)}`
      }
    },
    dateFrom() {
      return [...this.dates].sort()[0];
    },
    assignBinsOpen() {
      if (this.isAdmin) {
        return true;
      }
      return !!this.dateFrom && checkAssignBinsOpen({dateFrom: this.dateFrom, now: this.now});
    },
    assignOpensAtFormatted() {
      if (!this.dateFrom) {
        return '';
      }
      return getAssignBinsDeadline({dateFrom: this.dateFrom, returnMoment: true}).format('dddd, MMM D [at] h:mma');
    },
    dateTo() {
      return [...this.dates].sort().reverse()[0];
    },
    shipments() {
      let {orders} = this;
      orders = orders.filter(o => o.customer.address.use_shipping);
      return this.groupByCustomer(orders, 'uid');
    },
    bags() {
      let {orders, driverSelected, driversFiltered} = this;
      orders = orders.filter(o => !o.isOnfleetTask);
      const result = [];


      function binSort({bins: binA}, {bins: binB}) {
        return binA.join(',').localeCompare(binB.join(','));
      }

      // apply the manual sticker counts and the show/hide text filter before
      // anything downstream counts or renders the labels.
      const prepare = (labels) => labels
        .map(label => this.applyStickerOverride(label))
        .filter(label => this.matchesBagLabelFilter(label));

      // box and all racks print in bin order, without the driver stickers
      if (this.bagStickerSelector === 'box' || this.bagStickerSelector === 'all') {
        if (this.bagStickerSelector === 'box') {
          orders = orders.filter(o => isBoxBin(o.bin));
        }
        const {driverCounts, customerLabels} = BagCalc.computeBags(
          this.groupByCustomer(orders),
          this.rackConfigs
        )
        debug(`${this.bagStickerSelector} rack selected`, driverCounts, customerLabels);
        return prepare(customerLabels).sort(binSort);
      }

      if (this.bagStickerSelector === 'regular') {
        orders = orders.filter(o => !isBoxBin(o.bin));
      }


      let drivers;
      if (driverSelected) {
        orders = orders.filter(o => o.driver === driverSelected);
        drivers = [driverSelected];
      } else {
        drivers = ['Unassigned', ...driversFiltered.filter(d => d !== 'Unassigned')]
      }
      for (const driver of drivers) {
        const {customerLabels} = BagCalc.computeBags(
          this.groupByCustomer(orders.filter(o => o.driver === driver)),
          this.rackConfigs
        );
        const driverLabels = prepare(customerLabels.filter(c => c.driver === driver));
        if (driverLabels.length > 0) {
          result.push({
            isDriverLabel: true,
            driver: driver,
            count: driverLabels.reduce((sum, label) => sum + label.count, 0)
          })
          result.push(...driverLabels);
        }
      }

      return result;
    },
    selectedUids() {
      return [...new Set(this.ordersFiltered.map(o => o.uid))];
    },
    rawHeaders() {
      const headers = [
        {
          value: 'bin',
          text: 'bin'
        },
        {
          "value": "name",
          "text": "name"
        },
        {
          "value": "stream",
          "text": "stream"
        },
        {
          "value": "meal_size",
          "text": "meal_size"
        },
        // {
        //   "value": "order_type",
        //   "text": "order_type"
        // },
        {
          "value": "tod",
          "text": "tod"
        },
        // {
        //   "value": "lineItemRef",
        //   "text": "lineItemRef"
        // },
        // {
        //   "value": "uid",
        //   "text": "uid"
        // },
        {
          "value": "displayAllergies",
          "text": "displayAllergies"
        },
        // {
        //   "value": "order_id",
        //   "text": "order_id"
        // },
        // {
        //   "value": "id",
        //   "text": "id"
        // },
        // {
        //   "value": "first_name",
        //   "text": "first_name"
        // },
        // {
        //   "value": "last_name",
        //   "text": "last_name"
        // },
        // {
        //   "value": "email",
        //   "text": "email"
        // },
        // {
        //   "value": "phone_number",
        //   "text": "phone_number"
        // },
        // {
        //   "value": "plan",
        //   "text": "plan"
        // },
        {
          "value": "meal_id",
          "text": "meal_id"
        },
        {
          "value": "mealName",
          "text": "mealName"
        },
        {
          "value": "quantity",
          "text": "quantity"
        },
        {
          "value": "date",
          "text": "date"
        },
        {
          "value": "ship_date",
          "text": "ship_date"
        },

        // {
        //   "value": "customer",
        //   "text": "customer"
        // },
        // {
        //   "value": "driver",
        //   "text": "driver"
        // }
      ];
      return headers;
    },
    rawItems() {
      const items = this.ordersFiltered;
      debug('items', items);
      return items;
    },
    exportFilename() {
      return `packing-${this.dates.join('-')}-${this.shippingGroup}`;
    },
    rawItemsAsTable() {
      const headers = this.rawHeaders;
      return this.rawItems.map(item => {
        const result = {};
        headers.forEach(h => result[h.value] = item[h.value]);
        return result;
      });
    },
    customerTags() {
      const tags = new Set();
      this.ordersUnfiltered
        .forEach(order => {
            if (order.tags) {
              order.tags.forEach(t => tags.add(t));
            }
          }
        );
      return [...tags];
    },
    driversFiltered() {
      const {drivers, driverSelected} = this;
      return drivers.filter(d => driverSelected ? d === driverSelected : true)
        .filter(d => this.orders.some(o => o.driver === d))
    },
    assignedOrders() {
      return this.ordersFiltered.filter(o => !!o.bin);
    },
    racks() {
      return [...new Set(this.orders.map(o => (o.bin || '').split('-')[0]))].sort();
    },
    currentQuery() {
      return {...this.$route.query}
    },
    distributionCities() {
      const cities = new Set();
      this.ordersUnfiltered.forEach(o => o.email && cities.add(o.distributionCity));
      return [...cities];
    }
  },
  methods: {
    getDeliveryInstruction,
    isBoxBin,
    // Replaces the Vuex `getCustomer` getter: reads from the scoped customer map
    // loaded by CustomerLookup instead of the whole-directory fetchCustomers.
    getCustomer(uid) {
      return this.customers[uid];
    },
    getCustomerBins(customerOrders) {
      return [...new Set(customerOrders.flatMap(o => (o.bin || '?').split(',')))];
    },
    ...mapActions([
      'fetchDiets',
      'fetchMealsById',
      'fetchMealIngredients',
      'fetchOrdersByDate',
      'reload'
    ]),
    csvExport,
    range,
    getBagCount(orders) {
      return BagCalc.getNumberOfBags(orders);
    },
    setStickerOverride(customerName, value) {
      const count = Math.floor(Number(value));
      if (!count || count < 1) {
        this.clearStickerOverride(customerName);
        return;
      }
      this.$set(this.stickerOverrides, customerName, count);
    },
    clearStickerOverride(customerName) {
      this.$delete(this.stickerOverrides, customerName);
    },
    clearAllStickerOverrides() {
      this.stickerOverrides = {};
      this.bagStickerMultiplier = 1;
    },
    setStickerMultiplier(value) {
      this.bagStickerMultiplier = Math.max(Number(value) || 1, 1);
    },
    // a per-customer override replaces the multiplied count outright, so the
    // multiplier is the baseline everyone gets and the override is the exception.
    applyStickerOverride(label) {
      const multiplier = Math.max(Number(this.bagStickerMultiplier) || 1, 1);
      const calculatedCount = Math.max(1, Math.ceil(label.count * multiplier));
      const override = this.stickerOverrides[label.customerName];
      return {
        ...label,
        bagCalcCount: label.count,
        calculatedCount,
        count: override || calculatedCount
      };
    },
    // extra stickers beyond the bag calc count repeat the last QR code, so an
    // override never introduces QR values the rest of the system doesn't know.
    qrCodeForSticker(bag, sticker) {
      const {qrCodeValues} = bag;
      return qrCodeValues[Math.min(sticker, qrCodeValues.length) - 1];
    },
    // each sticker names its own box's bin when stickers map 1:1 to boxes
    // (split orders occupy two boxes, stickersPerBox configs repeat a bin);
    // any mismatch (overrides, multipliers, volume-driven extras) falls back
    // to every bin on every sticker
    binsForSticker(bag, sticker) {
      const bins = bag.bins || [];
      const perSticker = bag.binsPerSticker;
      if (perSticker && perSticker.length === bag.count) {
        return [perSticker[sticker - 1]];
      }
      if (bins.length > 1 && bins.length === bag.count) {
        return [bins[sticker - 1]];
      }
      return bins;
    },
    // blank means "no bound", so an explicit 0 has to survive this
    parseMealBound(value) {
      const text = `${value === null || value === undefined ? '' : value}`.trim();
      if (!text) return null;
      const bound = Number(text);
      return isNaN(bound) ? null : bound;
    },
    // the text query and the meal count bounds are matched together, and the
    // show/hide toggle then decides whether a match is kept or dropped
    matchesBagLabelFilter(label) {
      const query = (this.bagLabelFilter || '').trim().toLowerCase();
      const min = this.parseMealBound(this.bagLabelMealsMin);
      const max = this.parseMealBound(this.bagLabelMealsMax);
      if (!query && min === null && max === null) return true;
      const text = [
        label.customerName,
        label.driver,
        (label.bins || []).join(' '),
        label.address_line_1,
        label.address_line_2
      ].filter(Boolean).join(' ').toLowerCase();
      const meals = Number(label.mealCount) || 0;
      const found = (!query || text.includes(query))
        && (min === null || meals >= min)
        && (max === null || meals <= max);
      return this.bagLabelFilterMode === 'exclude' ? !found : found;
    },
    setDates() {
      const dates = this.dates;
      debug('set dates', dates.length, dates);
      if (this.isAdmin) {
        // this.dates = dates;
      } else {
        if (dates.length === 1) {
          this.dates = getProductionDays(dates[0]);
        }
      }
      debug('set dates', this.dates);
    },
    getDatesInRange() {
      const dates = [];
      if (!this.dateFrom || !this.dateTo) {
        return dates;
      }
      let from = dayjs(this.dateFrom);
      const to = dayjs(this.dateTo);

      const diffDays = to.diff(from, 'day');
      if (diffDays >= 0 && diffDays <= 31) {
        // debug('adding days ', {from, to})
        while (!from.isAfter(to)) {
          const dateString = from.format('YYYY-MM-DD');
          // debug('added date', dateString);
          dates.push(dateString);
          from = from.add(1, 'day');
        }
      } else {
        window.alert(diffDays + ' days is above the limit of 7');
      }
      // debug('getDatesInRange', dates);
      return dates;
    },
    async fetchData() {
      this.error = this.post = null

      const {dates, shippingGroup} = this;
      if (!dates || dates.length === 0) {
        debug('no dates, no fetch');
        this.loading = false;
        return;
      }
      if (!shippingGroup) {
        debug('no shippingGroup, no fetch');
        this.loading = false;
        return;
      }

      if (this.currentData && diff(this.currentData, {dates, shippingGroup}).length === 0) {
        debug('already loading', this.currentData);
        return;
      } else {
        debug('loading packing', {dates, shippingGroup});
        this.currentData = {dates, shippingGroup};
      }


      this.loading = true;
      const orders = await this.fetchOrders();

      const meals = {};
      // debug('ordersByDate', ordersByDate);
      orders.forEach(order => {
        const mealCount = meals[order.meal_id] || {};
        mealCount[order.meal_size] = mealCount[order.meal_size] || 0;
        mealCount[order.meal_size]++;
        meals[order.meal_id] = mealCount;
      });
      // debug('meals', meals);
      await Promise.all([
          this.fetchMealsById(Object.keys(meals))
            .then((meals) => debug('meals loaded', meals)),
          this.fetchDriverTasks(),
          // Only load the customers referenced by these orders, projected to the
          // fields this view actually uses (see CUSTOMER_FIELDS).
          customerLookup.load(orders.map(o => o.uid))
            .then((map) => this.customers = map)
        ]
      ).catch((e) => {
        console.error('something went wrong', e);
      })
        .finally(() => {
          this.loading = false;
          this.pageLoadedDate = new Date();
          if (this.filterDistributionCity) {
            if (!this.distributionCities.includes(this.filterDistributionCity)) {
              this.filterDistributionCity = undefined;
            }
          }
        });
    },
    fetchDriverTasks() {
      return api.get('v2/onfleet/driver-tasks')
        .then(({data}) => {
          debug('onfleet/driver-tasks', data);
          this.driverTasks = data;
        });
    },
    meal_sizes() {
      return 'small,medium,large'.split(',');
    },
    closeDatePicker() {
      this.showDatePicker = false;
      this.$nextTick(() => this.fetchData());
    },
    dateFormatted,
    getEmails(orders) {
      const emails = new Set()
      orders.forEach(o => o.email && emails.add(o.email));
      // orders.forEach(o => o.email && emails.add(`${o.first_name} ${o.last_name} <${o.email}>`));
      return [...emails];
    },
    getEmailChunks(orders, chunkSize) {
      const emails = this.getEmails(orders);
      const chunks = [];
      let i = 0;
      while (i < emails.length) {
        const upper = Math.min(chunkSize + i, emails.length);
        chunks.push({chunk: `${i + 1} to ${upper}`, emails: emails.slice(i, upper)});
        i += chunkSize;
      }
      return chunks;
    },
    sortByBin(groupedOrders) {
      const entries = Object.entries(groupedOrders);
      const sortedEntries = entries.sort((e1, e2) => (e1[1][0].bin || '').localeCompare(e2[1][0].bin || ''));
      return Object.fromEntries(
        sortedEntries
      );
    },
    groupByCustomer(orders, key = 'name') {
      const result = {};
      const nameToUidMap = {};
      orders.forEach(o => {
        const name = (this.showUid ? o.name + '-' + o.uid : o.name).trim();
        nameToUidMap[name] = nameToUidMap[name] || new Set();
        nameToUidMap[name].add(o.addressFormatted);
      });
      orders.forEach(o => {
        if (key === 'name') {
          let name = (this.showUid ? o.name + '-' + o.uid : o.name).trim();
          if (nameToUidMap[name].size > 1) {
            const uniqueNumber = [...nameToUidMap[name]].findIndex(uid => uid === o.addressFormatted);
            name = `${name} (${uniqueNumber + 1})`;
          }
          result[name] = result[name] || [];
          result[name].push(o);
        }
        if (key === 'uid') {
          const name = o.uid;
          result[name] = result[name] || [];
          result[name].push(o);
        }
      });
      const sortedKeys = Object.keys(result).sort((a, b) => {
        const [orderA] = result[a];
        const [orderB] = result[b];
        if (orderA && orderA.eta && orderB && orderB.eta) {
          return orderA.eta - orderB.eta
        } else {
          return a.localeCompare(b);
        }
      });
      const sortedResult = {};
      sortedKeys.forEach(c => sortedResult[c] = result[c]);
      return sortedResult;
    },
    groupByMeal(orders) {
      const result = {};
      orders.forEach(o => {
        const name = `${o.mealName} (${o.stream}-${o.meal_id})`;
        result[name] = result[name] || [];
        result[name].push(o);
      });
      const sortedKeys = Object.keys(result).sort();
      const sortedResult = {};
      sortedKeys.forEach(c => sortedResult[c] = result[c]);
      return sortedResult;
    },
    timeOfDay(a, b) {
      return ((a.tod || '').localeCompare((b.tod | '')));
    },
    hasLastBinCheck(orders) {
      return orders.some(o => o.customer.last_bin_check);
    },
    getCount(mealOrders) {
      return mealOrders.map(m => m.quantity).reduce((a, s) => a + s, 0);
    },
    hasComment(customerOrders) {
      const customersMap = Object.fromEntries(customerOrders.map(o => ([o.uid, o])));
      const comments = new Set();
      Object.values(customersMap).forEach(customerOrder => {
        let date = customerOrder.ship_date;
        const shipDate = dayjs(customerOrder.ship_date)
        if (shipDate.format('ddd') === 'Mon') {
          date = shipDate.subtract(1, 'day').format('YYYY-MM-DD');
        }

        function inRange({start, end}) {
          return (!start || start <= date) && (!end || end >= date)
        }

        const customer = customerOrder && customerOrder.customer;

        const comment = customer && customer.comment;
        if (comment) comments.add(comment);
        if (customer.customer_notes) {
          const activeNotes = customer.customer_notes.filter(inRange);
          activeNotes.forEach(note => comments.add(note.text))
        }
      });
      if (comments.size > 0)
        return [...comments]
      else return false;
    },
    isFirstOrder(customerOrder) {
      return customerOrder && customerOrder.isFirstOrder;
    },
    assignBins() {
      const standardWarning = `
Are you sure you would like to assign bins?  This must not be performed after printing!

Any existing bin labels will *not* be changed.
`;
      const adminWarning = `You are using the ADMIN version.

Are you sure you would like to assign bins?  This must not be performed after printing!

Any existing bin labels will *not* be changed.

Note that ANY dates can be selected (eg, Mon/Tue, or Mon, Tue, Wed) for this to work.`
      if (confirm(this.isAdmin ? adminWarning : standardWarning)) {
        this.showAssignInProgress = true;
        const payload = {
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
          shippingGroups: [this.shippingGroup]
        };
        if (this.isAdmin) {
          payload['isAdmin'] = true;
        }
        // the api waits for the postgres sync before responding, so re-fetch straight away
        api.post('v2/order/assign-bins', payload)
          .then(() => this.fetchOrders())
          .finally(() => this.showAssignInProgress = false);
      }
    },
    clearBins() {
      const dateFrom = this.dateFrom;
      const dateTo = this.dateTo;
      if (confirm(`
Are you sure you would like to clear bin assignments for all orders between ${dateFrom} and ${dateTo}?

This should not be performed after printing meal labels.
`)) {
        this.showClearInProgress = true;
        const payload = {
          dateFrom: dateFrom,
          dateTo: dateTo,
          shippingGroups: [this.shippingGroup]
        };
        if (this.isAdmin) {
          payload['isAdmin'] = true;
        }
        api.post('v2/order/clear-bins', payload)
          .then(() => this.fetchOrders())
          .finally(() => this.showClearInProgress = false);
      }
    },
    sortBySize(orders) {
      const sizeMap = {small: 0, medium: 1, large: 2};
      const size = s => sizeMap[s.meal_size];
      const sortFunction = (a, b) => size(a) - size(b) || a.name.localeCompare(b.name);
      return [...orders].sort(sortFunction);
    },
    filterByTod(customerOrders, tod, include) {
      return include
        ? customerOrders.filter(o => tod === o.tod)
        : customerOrders.filter(o => tod !== o.tod)
    },
    async exportToOnfleet() {
      this.exporting = true;
      const payload = {dateFrom: this.dateFrom, dateTo: this.dateTo};

      if (this.isFiltered) {
        const uids = this.selectedUids;
        debug('filtered, so partial export', uids);
        payload.uids = uids;
      }
      if (this.overrideShipDate) {
        payload.forceShipDate = this.overrideShipDate;
      }

      this.showExportDialog = true;
      let exporting = true;

      const updateStatus = (r) => {
        debug('response', r);
        this.exportStatus = r.data;
        exporting = this.exportStatus.exportInProcess;
      }

      await api.post('v2/onfleet/', payload)
        .then(r => updateStatus(r))
        .catch(e => console.error('fail', e))


      while (exporting) {
        await new Promise(resolve => setTimeout(() => resolve(), 1000));
        api.post('v2/onfleet/', payload, {params: {check: true}})
          .then(r => updateStatus(r))
          .catch(e => console.error('fail', e));
      }
      this.exporting = false;
    },
    getDistributionCity(customerOrders) {
      return [...new Set(customerOrders.map(o => o.distributionCity))];
    },
    getCustomerLocations(customerOrders) {
      return [...new Set(customerOrders.map(o => {
        const customer = o.customer || this.getCustomer(o.uid);
        return customer.address.location;
      }))];
    },
    getCustomerDeliveryDates(customerOrders) {
      return [...new Set(customerOrders.map(o => o.ship_date))];
    },
    getDeliveryStatus(customerOrders) {
      const logistics = customerOrders[0].logistics;
      if (!logistics) {
        return [];
      }
      /** FIXME: this isn't really great - shipments should not be saved inside each order record
       * we presume that the order line item record contains all the shipments of the week (not just
       * the day a particular line item is on */
      const ship_dates = [...new Set(customerOrders.map(o => o.ship_date))]
        .map(date => dayjs(date).format('ddd').toLowerCase());
      const filtered = logistics
        .filter(s => ship_dates.includes(s.day))
      if (filtered.length > 0) {
        return filtered;
      } else {
        return logistics;
      }
    },
    formatOnfleetPayload(payload) {
      return payload && payload.recipients
        ? payload.recipients.map(({name, notes, phone}) => `${name} (${phone}): ${notes}`).join(', ')
        : '';
    },
    getCustomerName(uid) {
      const c = this.getCustomer(uid);
      return `${c.first_name} ${c.last_name}`
    },
    formatAddress(a) {
      function formatPostcode(s) {
        return (s || '').replace(' ', '').toUpperCase();
      }

      return `${[
        (a.unit ? `${a.unit}-` : '') + a.line1,
        a.line2,
        // a.city,
        formatPostcode(a.postal_code)
      ]
        .filter(a => !!a)
        .join(', ')
      }`;
    },
    copyToClipboard(text) {
      try {
        navigator.clipboard.writeText(text);
      } catch (e) {
        alert('sorry, copy not supported on this device: ' + e.message)
      }
    },
    linkTask(uid, onfleetShortId) {
      const dates = this.getCustomerDeliveryDates(this.orders.filter(o => o.uid === uid));
      if (dates.length > 1) {
        alert('there was more than one customer delivery date: ' + dates.join(', '));
      }
      const [date] = dates;
      debug('customer delivery dates', dates);
      const payload = {
        uid,
        date,
        onfleetShortCode: onfleetShortId
      };
      debug('payload', payload);

      api
        .post('v2/onfleet/link', payload)
        .then(r => {
          debug('done', r);
          alert('task has been linked.  eta and driver assignment will be updated in ~5 mins');
          this.showLinkDialog = false;
          this.onfleetUid = '';
          this.onfleetShortId = '';
        })
        .catch(e => console.error('fail', e));
    },
    filterByRack(orders, rack) {
      return orders.filter(o => (o.bin || '').split('-')[0] === rack);
    },
    async fetchOrders() {
      const params = {
        from: this.dateFrom,
        to: this.dateTo,
        shippingGroups: [this.shippingGroup],
        include_container_size: true
        // properties: ['quantity', 'allergyDetected', 'allergies', 'meal_id', 'stream', 'tod', 'meal_size'],
      };
      debug('fetching ', params);
      const orders = await api
        .get('v2/order/search', {params})
        .then(({data}) => data);
      this.ordersFetched = orders;
      return orders;
    },
  },
  props: {
    isAdmin: {type: Boolean, default: false, required: false},
    isDelivery: {type: Boolean, default: false, required: false},
  }
}
</script>

<style scoped>
.border_all {
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 4px;
  padding: 0 12px;
}
</style>
